import React from 'react';
import {
  CheckPicker,
  Button,
  Table,
  Uploader,
  Col,
  Stack,
  Drawer,
  Checkbox,
  Panel,
  FlexboxGrid,
  ButtonToolbar,
  Input,
  InputGroup,
  InputNumber,
  SelectPicker,
  IconButton,
  Tooltip,
  Whisper
} from 'rsuite';
import globalIP from '@/GlobelIP';
import TrashIcon from '@rsuite/icons/Trash';
import PlusIcon from '@rsuite/icons/Plus';
import EditIcon from '@rsuite/icons/Edit';
const { Column, HeaderCell, Cell } = Table;
const ip = globalIP;
const ProductFamily = ({
  data5,
  //Sslecters Data
  colordata,
  finishdata,
  variantData,
  size,
  materialdata,
  handleUploadVarImage,
  handleOpenne,
  handleOpencbm,
  handleRemoveVariant,
  //State manage
  showPname,
  showDesc,
  showFinish,
  showSize,
  showLength,
  showWidth,
  showHeight,
  showMoq,
  showNTW,
  showGRW,
  showMat,
  showbuyersku,
  fileInfo,
  showColor,
  label,
  variantttdata,
  setVariantData,
  // For Update Product
  updateid,
  // For Drawer
  open,
  numVariants,
  setOpen,
  setPName,
  setShowColor,
  setShowLength,
  setShowWidth,
  setShowHeight,
  setShowFinish,
  setShowSize,
  setShowDesc,
  setShowMoq,
  setShowNTW,
  setShowGRW,
  handleAddVariants,
  setNumVariants,
  setShowMat
}) => {
  const numberToLetters = (num) => {
    let letters = '';
    num++; // make 0 => A
    while (num > 0) {
      num--; // adjust for 0-index
      letters = String.fromCharCode(65 + (num % 26)) + letters;
      num = Math.floor(num / 26);
    }
    return letters;
  };

  // Convert a letter sequence back to number: A -> 0, Z -> 25, AA -> 26, AB -> 27 ...
  const lettersToNumber = (letters) => {
    let num = 0;
    for (let i = 0; i < letters.length; i++) {
      num = num * 26 + (letters.charCodeAt(i) - 65 + 1);
    }
    return num - 1; // 0-indexed
  };

  const getNextLetterId = (baseId, existingIds) => {
    // Filter IDs starting with baseId
    const relatedIds = existingIds.filter(id => id.startsWith(baseId));

    // Extract letters at the end
    const letters = relatedIds
      .map(id => {
        const match = id.match(/[A-Z]+$/); // match 1+ letters at the end
        return match ? match[0] : null;
      })
      .filter(Boolean);

    if (!letters.length) return baseId + 'A';

    // Convert letters to numbers to find max
    const numbers = letters.map(lettersToNumber);
    const maxNum = Math.max(...numbers);

    // Next letter sequence
    const nextLetters = numberToLetters(maxNum + 1);
    return baseId + nextLetters;
  };

  return (
    <>
      <Stack justifyContent="flex-end">
        <ButtonToolbar style={{ marginBottom: '5px' }}>
          <IconButton icon={<PlusIcon />} onClick={() => setOpen(true)} active>
            Add Variants
          </IconButton>
        </ButtonToolbar>
      </Stack>

      <Table
        virtualized // Enable virtualization for better performance with large datasets
        data={variantData}
        height={380} // Set the desired table height
        rowHeight={80}
        bordered
        cellBordered
      >
        <Column>
          <HeaderCell>
            <Stack>
              <b>Image</b>
              <p style={{ color: 'red' }}>*</p>
            </Stack>
          </HeaderCell>
          <Cell>
            {(rowData, rowIndex) => (
              <div>
                <Uploader
                  autoUpload={false}
                  onChange={fileList => handleUploadVarImage(fileList, rowIndex)}
                  fileList={[]}
                  accept="image/jpeg,image/jpg"
                  action={''}
                >
                  {rowData.customCoverImage ? (
                    <img
                      src={rowData.customCoverImage}
                      alt="Cover Image"
                      style={{ width: '74px', height: '56px', objectFit: 'contain' }}
                    />
                  ) : (
                    <img
                      src={fileInfo}
                      style={{ width: '74px', height: '56px', objectFit: 'contain' }}
                    />
                  )}
                </Uploader>
              </div>
            )}
          </Cell>
        </Column>
        <Column width={150} align="center">
          <HeaderCell>
            <b>{label[0]?.attributes.AliasCode}</b>
          </HeaderCell>

          {/* <Cell>
            {(rowData, rowIndex) => {
              const originalProductId = data5.ProductId; // e.g., "K-01"
              
              // 🔹 Collect all numeric suffixes after a dash
              const existingSuffixes = variantttdata
              .map(item => {
                const id = item.attributes.ProductId;
                const match = id.match(/-(\d+)$/); // match last -number
                return match ? parseInt(match[1], 10) : 0;
              })
              .filter(num => num > 0);
              
              // 🔹 Find max number used so far (0 if none)
              const maxSuffix = existingSuffixes.length ? Math.max(...existingSuffixes) : 0;
              // 🔹 Generate the next running number (continuing sequence)
              const nextSuffix = maxSuffix + (rowIndex + 1);
              const defaultVariantProductId = `${originalProductId}-${nextSuffix}`;
              
              // console.log(rowData.ProductId,defaultVariantProductId)
              return (
                <Input
                  value={rowData.ProductId || defaultVariantProductId}
                  onChange={value => {
                    const newVariantData = [...variantData];
                    newVariantData[rowIndex].ProductId = value;
                    setVariantData(newVariantData);
                  }}
                />
              );
            }}
          </Cell> */}
          <Cell>
            {(rowData, rowIndex) => {
              const originalProductId = data5.ProductId; // e.g., "AH-D-0038"

              // Collect existing ProductIds
              const existingIds = variantttdata.map(item => item.attributes.ProductId);

              const defaultVariantProductId = getNextLetterId(originalProductId, existingIds);

              return (
                <Input
                  value={rowData.ProductId || defaultVariantProductId}
                  onChange={(value) => {
                    const newVariantData = [...variantData];
                    newVariantData[rowIndex].ProductId = value;
                    setVariantData(newVariantData);
                  }}
                />
              );
            }}
          </Cell>


        </Column>
        {showPname && (
          <Column width={150} align="center">
            <HeaderCell>
              <b>{label[0]?.attributes?.ProductName}</b>
            </HeaderCell>
            <Cell dataKey="ProductName">
              {(rowData, rowIndex) => (
                <Input
                  value={rowData.ProductName}
                  onChange={value => {
                    const newVariantData = [...variantData];
                    newVariantData[rowIndex].ProductName = value;
                    setVariantData(newVariantData);
                  }}
                />
              )}
            </Cell>
          </Column>
        )}
        {showDesc && (
          <Column width={150} align="center">
            <HeaderCell>
              <b>{label[0]?.attributes?.Description}</b>
            </HeaderCell>
            <Cell dataKey="Description">
              {(rowData, rowIndex) => (
                <Input
                  value={rowData.Description}
                  onChange={value => {
                    const newVariantData = [...variantData];
                    newVariantData[rowIndex].Description = value;
                    setVariantData(newVariantData);
                  }}
                />
              )}
            </Cell>
          </Column>
        )}
        {showColor && (
          <Column width={120} align="center">
            <HeaderCell>
              <b>{label[0]?.attributes?.color}</b>
            </HeaderCell>
            <Cell dataKey="ColorName">
              {(rowData, rowIndex) => (
                <SelectPicker
                  value={rowData.ColorName}
                  onChange={value => {
                    const newVariantData = [...variantData];
                    newVariantData[rowIndex].ColorName = value;
                    setVariantData(newVariantData);
                  }}
                  data={colordata}
                  placeholder="Select"
                  labelKey="label"
                  valueKey="label"
                />
              )}
            </Cell>
          </Column>
        )}
        {showFinish && (
          <Column width={120} align="center">
            <HeaderCell>
              <b>{label[0]?.attributes?.finish}</b>
            </HeaderCell>
            <Cell dataKey="FinishName">
              {(rowData, rowIndex) => (
                <SelectPicker
                  value={rowData.FinishName}
                  onChange={value => {
                    const newVariantData = [...variantData];
                    newVariantData[rowIndex].FinishName = value;
                    setVariantData(newVariantData);
                  }}
                  data={finishdata}
                  placeholder="Select"
                  labelKey="label"
                  valueKey="label"
                />
              )}
            </Cell>
          </Column>
        )}
        {showSize && (
          <Column width={120} align="center">
            <HeaderCell>
              <b> {label[0]?.attributes?.Sizeunit}</b>
            </HeaderCell>
            <Cell dataKey="SizeUnit">
              {(rowData, rowIndex) => (
                <div id="custom-container" style={{ position: 'relative' }}>
                  <SelectPicker
                    value={rowData.SizeUnit}
                    onChange={value => {
                      const newVariantData = [...variantData];
                      newVariantData[rowIndex].SizeUnit = value;
                      setVariantData(newVariantData);
                    }}
                    data={size}
                    placeholder="Select"
                    container={() => document.getElementById('custom-container')}
                  />
                </div>
              )}
            </Cell>
          </Column>
        )}
        {showLength && (
          <Column align="center">
            <HeaderCell>
              <b> {label[0]?.attributes?.length}</b>
            </HeaderCell>
            <Cell dataKey="Length">
              {(rowData, rowIndex) => (
                <InputNumber
                  step={null}
                  value={rowData.Length || 0}
                  onChange={value => {
                    const enteredValue = String(value);
                    if (parseFloat(enteredValue) >= 0 || enteredValue === '') {
                      // Allow positive values or empty string
                      const newVariantData = [...variantData];
                      newVariantData[rowIndex].Length = value;
                      setVariantData(newVariantData);
                    } else {
                      handleOpenne();
                    }
                  }}
                // onBlur={value => {
                //   const enteredValue = String(rowData.Length);
                //   if (enteredValue === '' || parseFloat(enteredValue) >= 0) {
                //     const newVariantData = [...variantData];
                //     newVariantData[rowIndex].Length = enteredValue === '' ? 0 : value;
                //     setVariantData(newVariantData);
                //   } else {
                //     handleOpenne();
                //   }
                // }}
                />
              )}
            </Cell>
          </Column>
        )}
        {showWidth && (
          <Column align="center">
            <HeaderCell>
              <b>{label[0]?.attributes?.width}</b>
            </HeaderCell>
            <Cell dataKey="Width">
              {(rowData, rowIndex) => (
                <InputNumber
                  step={null}
                  value={rowData.Width || 0}
                  onChange={value => {
                    const enteredValue = String(value);
                    if (parseFloat(enteredValue) >= 0 || enteredValue === '') {
                      // Allow positive values or empty string
                      const newVariantData = [...variantData];
                      newVariantData[rowIndex].Width = value;
                      setVariantData(newVariantData);
                    } else {
                      handleOpenne();
                    }
                  }}
                // onBlur={value => {
                //   const enteredValue = String(rowData.Width);
                //   if (enteredValue === '' || parseFloat(enteredValue) >= 0) {
                //     const newVariantData = [...variantData];
                //     newVariantData[rowIndex].Width = enteredValue === '' ? 0 : value;
                //     setVariantData(newVariantData);
                //   } else {
                //     handleOpenne();
                //   }
                // }}
                />
              )}
            </Cell>
          </Column>
        )}
        {showHeight && (
          <Column align="center">
            <HeaderCell>
              <b>{label[0]?.attributes?.height}</b>
            </HeaderCell>
            <Cell dataKey="Height">
              {(rowData, rowIndex) => (
                <InputNumber
                  step={null}
                  value={rowData.Height || 0}
                  onChange={value => {
                    const enteredValue = String(value);
                    if (parseFloat(enteredValue) >= 0 || enteredValue === '') {
                      // Allow positive values or empty string
                      const newVariantData = [...variantData];
                      newVariantData[rowIndex].Height = value;
                      setVariantData(newVariantData);
                    } else {
                      handleOpenne();
                    }
                  }}
                // onBlur={value => {
                //   const enteredValue = String(rowData.Height);
                //   if (enteredValue === '' || parseFloat(enteredValue) >= 0) {
                //     const newVariantData = [...variantData];
                //     newVariantData[rowIndex].Height = enteredValue === '' ? 0 : value;
                //     setVariantData(newVariantData);
                //   } else {
                //     handleOpenne();
                //   }
                // }}
                />
              )}
            </Cell>
          </Column>
        )}
        {showMoq && (
          <Column align="center">
            <HeaderCell>
              <b>{label[0]?.attributes?.MOQ}</b>
            </HeaderCell>
            <Cell dataKey="MOQ">
              {(rowData, rowIndex) => (
                <InputNumber
                  step={null}
                  value={rowData.MOQ || 0}
                  onChange={value => {
                    const enteredValue = String(value).trim();
                    const parsedValue = enteredValue === '' ? 0 : parseInt(enteredValue, 10);

                    if (!isNaN(parsedValue) && parsedValue >= 0) {
                      // Allow only valid positive integer values
                      const newVariantData = [...variantData];
                      newVariantData[rowIndex].MOQ = parsedValue;
                      setVariantData(newVariantData);
                    } else {
                      handleOpenne();
                    }
                  }}
                />
                // <InputNumber
                //   step={null}
                //   value={rowData.MOQ || 0}
                //   onChange={value => {
                //     const enteredValue = String(value);
                //     if (parseFloat(enteredValue) >= 0 || enteredValue === '') {
                //       // Allow positive values or empty string
                //       const newVariantData = [...variantData];
                //       newVariantData[rowIndex].MOQ = value;
                //       setVariantData(newVariantData);
                //     } else {
                //       handleOpenne();
                //     }
                //   }}
                // />
              )}
            </Cell>
          </Column>
        )}
        {showNTW && (
          <Column align="center">
            <HeaderCell>
              <b> {label[0]?.attributes?.NetWgt}</b>
            </HeaderCell>
            <Cell dataKey="NetWeight">
              {(rowData, rowIndex) => (
                <InputNumber
                  step={null}
                  value={rowData.NetWeight || 0}
                  onChange={value => {
                    const enteredValue = String(value);
                    if (parseFloat(enteredValue) >= 0 || enteredValue === '') {
                      // Allow positive values or empty string
                      const newVariantData = [...variantData];
                      newVariantData[rowIndex].NetWeight = value;
                      setVariantData(newVariantData);
                    } else {
                      handleOpenne();
                    }
                  }}
                // onBlur={value => {
                //   const enteredValue = String(rowData.NetWeight);
                //   if (enteredValue === '' || parseFloat(enteredValue) >= 0) {
                //     const newVariantData = [...variantData];
                //     newVariantData[rowIndex].NetWeight = enteredValue === '' ? 0 : value;
                //     setVariantData(newVariantData);
                //   } else {
                //     handleOpenne();
                //   }
                // }}
                />
              )}
            </Cell>
          </Column>
        )}
        {showGRW && (
          <Column align="center">
            <HeaderCell>
              <b>{label[0]?.attributes?.GrossWgt}</b>
            </HeaderCell>
            <Cell dataKey="NetWeight">
              {(rowData, rowIndex) => (
                <InputNumber
                  step={null}
                  value={rowData.GrossWeight || 0}
                  onChange={value => {
                    const enteredValue = String(value);
                    if (parseFloat(enteredValue) >= 0 || enteredValue === '') {
                      // Allow positive values or empty string
                      const newVariantData = [...variantData];
                      newVariantData[rowIndex].GrossWeight = value;
                      setVariantData(newVariantData);
                    } else {
                      handleOpenne();
                    }
                  }}
                // onBlur={value => {
                //   const enteredValue = String(rowData.GrossWeight);
                //   if (enteredValue === '' || parseFloat(enteredValue) >= 0) {
                //     const newVariantData = [...variantData];
                //     newVariantData[rowIndex].GrossWeight = enteredValue === '' ? 0 : value;
                //     setVariantData(newVariantData);
                //   } else {
                //     handleOpenne();
                //   }
                // }}
                />
              )}
            </Cell>
          </Column>
        )}
        {showMat && (
          <Column width={200} align="center">
            <HeaderCell>
              <b> {label[0]?.attributes?.MaterialName}</b>
            </HeaderCell>
            <Cell dataKey="ProductionDetail">
              {(rowData, rowIndex) => (
                <CheckPicker
                  value={rowData.ProductionDetail.filter(detail => detail.MaterialNm).map(
                    detail => detail.MaterialNm
                  )}
                  onChange={selectedValues => {
                    const newVariantData = [...variantData];

                    // Filter out empty entries from ProductionDetail
                    const filteredProductionDetails = newVariantData[
                      rowIndex
                    ].ProductionDetail.filter(detail => detail.MaterialNm);

                    // Map selected materials to ProductionDetail entries
                    const updatedProductionDetails = selectedValues.map(material => {
                      const existingDetail = filteredProductionDetails.find(
                        detail => detail.MaterialNm === material
                      );
                      const selectedMaterialData = materialdata.find(
                        item => item.label === material
                      );
                      return (
                        existingDetail || {
                          ProductCode: newVariantData[rowIndex].ProductCode,
                          MaterialNm: material,
                          MaterialFinishNm: '',
                          MatNetWeight: 0,
                          MaterialCode: selectedMaterialData ? selectedMaterialData.value : '',
                          MaterialFinishCode: '',
                          Component: '',
                          Unit: 'inch',
                          Length: 0,
                          Width: 0,
                          Height: 0,
                          Depth: 0,
                          Qty: 0
                        }
                      );
                    });

                    // Assign the filtered and updated ProductionDetail back to the row
                    newVariantData[rowIndex].ProductionDetail = updatedProductionDetails;
                    setVariantData(newVariantData);
                  }}
                  data={materialdata}
                  placeholder="Select Materials"
                  labelKey="label"
                  valueKey="label"
                  placement="autoVerticalStart"
                  searchable
                  block
                />
              )}
            </Cell>
          </Column>
        )}
        <Column align="center">
          <HeaderCell>
            <b> {label[0]?.attributes?.Currency}</b>
          </HeaderCell>
          <Cell dataKey="SellingPrice">
            {(rowData, rowIndex) => <Input value={data5.SellingPriceCurrency} disabled />}
          </Cell>
        </Column>
        <Column align="center">
          <HeaderCell>
            <b> {label[0]?.attributes?.SalePrice}</b>
          </HeaderCell>
          <Cell dataKey="SellingPrice">
            {(rowData, rowIndex) => <Input value={data5.SellingPrice} disabled />}
          </Cell>
        </Column>
        <Column align="center">
          <HeaderCell>
            <b> {label[0]?.attributes?.cbm}</b>
          </HeaderCell>
          <Cell dataKey="SellingPrice">
            {(rowData, rowIndex) => <Input value={data5.cbm} disabled />}
          </Cell>
        </Column>
        {showbuyersku && (
          <Column width={150} align="center">
            <HeaderCell>
              <b> {label[0]?.attributes?.BuyerSku}</b>
            </HeaderCell>
            <Cell dataKey="BuyerSku">
              {(rowData, rowIndex) => <Input value={data5.BuyerSku} />}
            </Cell>
          </Column>
        )}
        <Column align="center">
          <HeaderCell>
            <b> {label[0]?.attributes?.ProductRemark}</b>
          </HeaderCell>
          <Cell dataKey="BuyerSku">{(rowData, rowIndex) => <Input disabled />}</Cell>
        </Column>
        <Column align="center">
          <HeaderCell>
            <b>Pack</b>
          </HeaderCell>
          <Cell>
            {(rowData, rowIndex) => (
              <IconButton
                icon={<EditIcon />}
                circle
                size="xs"
                style={{ marginLeft: '5px' }}
                onClick={() => handleOpencbm(rowIndex)}
              />
            )}
          </Cell>
        </Column>
        <Column width={100} align="center">
          <HeaderCell>
            <b>Actions</b>
          </HeaderCell>
          <Cell>
            {(rowData, rowIndex) => (
              <IconButton
                icon={<TrashIcon />}
                onClick={() => handleRemoveVariant(rowIndex)}
                active
              />
            )}
          </Cell>
        </Column>
        {/* Add more columns for other properties like Description, MOQ, Net. Wt., etc. */}
      </Table>
      {updateid ? (
        <>
          <h5>Variants</h5>
          <Table height={300} data={variantttdata} bordered cellBordered rowHeight={60}>
            <Column width={100}>
              <HeaderCell>
                <b>Sr. No.</b>
              </HeaderCell>
              <Cell>{(_, rowIndex) => rowIndex + 1}</Cell>
            </Column>
            <Column width={150} align="center">
              <HeaderCell>
                <b>{label[0]?.attributes?.AliasCode}</b>
              </HeaderCell>
              <Cell dataKey={'attributes.ProductId'} />
            </Column>
            <Column width={150} align="center">
              <HeaderCell>
                <b>Image</b>
              </HeaderCell>
              <Table.Cell>
                {rowData => {
                  // Define a function to show the enlarged image on hover
                  const renderTooltip = imageSrc => (
                    <Tooltip style={{ backgroundColor: 'white' }}>
                      <img
                        src={imageSrc}
                        alt="Product Image"
                        style={{ width: 400, height: 'auto' }}
                      />
                    </Tooltip>
                  );

                  return (
                    <Whisper
                      followCursor
                      trigger="hover"
                      placement="right"
                      speaker={renderTooltip(
                        `${ip}${rowData.attributes.CoverImage.data.attributes.url}`
                      )}
                    >
                      <img
                        src={`${ip}${rowData.attributes.CoverImage.data.attributes.url}`}
                        alt="Product Image"
                        style={{
                          width: 50,
                          height: 50,
                          marginTop: '-8px',
                          objectFit: 'contain'
                        }}
                      />
                    </Whisper>
                  );
                }}
              </Table.Cell>
            </Column>
            <Column width={150} align="center">
              <HeaderCell>
                <b>{label[0]?.attributes?.ProductName}</b>
              </HeaderCell>
              <Cell dataKey={'attributes.ProductName'} />
            </Column>
            <Column width={150} align="center">
              <HeaderCell>
                <b>{label[0]?.attributes?.Description}</b>
              </HeaderCell>
              <Cell dataKey={'attributes.Description'} />
            </Column>
            <Column width={150} align="center">
              <HeaderCell>
                <b>{label[0]?.attributes?.Sizeunit}</b>
              </HeaderCell>
              <Cell>
                {rowData => {
                  const { Length, Width, Height, SizeUnit } = rowData.attributes;
                  const sizeInfo = `${Length} x ${Width} x ${Height} ${SizeUnit}`;
                  return sizeInfo;
                }}
              </Cell>
            </Column>
            <Column width={150} align="center">
              <HeaderCell>
                <b>{label[0]?.attributes?.finish}</b>
              </HeaderCell>
              <Cell dataKey={'attributes.FinishName'} />
            </Column>
            <Column width={150} align="center">
              <HeaderCell>
                <b>{label[0]?.attributes?.color}</b>
              </HeaderCell>
              <Cell dataKey={'attributes.ColorName'} />
            </Column>
            <Column width={150} align="center">
              <HeaderCell>
                <b>{label[0]?.attributes?.MOQ}</b>
              </HeaderCell>
              <Cell dataKey={'attributes.MOQ'} />
            </Column>
            <Column width={150} align="center">
              <HeaderCell>
                <b>{label[0]?.attributes?.NetWgt}</b>
              </HeaderCell>
              <Cell dataKey={'attributes.NetWeight'} />
            </Column>
          </Table>
        </>
      ) : (
        <></>
      )}
      <Drawer open={open} onClose={() => setOpen(false)}>
        <Drawer.Header>
          <Drawer.Title>Add Variants</Drawer.Title>
          <Drawer.Actions>
            <Button color="cyan" appearance="primary" onClick={handleAddVariants}>
              Confirm
            </Button>
          </Drawer.Actions>
        </Drawer.Header>
        <Drawer.Body>
          <Panel>
            <Stack spacing={100}>
              Variants:
              <InputGroup>
                <InputNumber
                  id="numVariants"
                  value={numVariants}
                  onChange={value => setNumVariants(value)}
                  min={0}
                />
              </InputGroup>
            </Stack>
          </Panel>
          <Panel>
            <p>Suggested</p>
            <Stack justifyContent="flex-start" spacing={12}>
              <FlexboxGrid justify="space-around">
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Checkbox checked={showPname} onChange={() => setPName(!showPname)}>
                    {label[0]?.attributes?.ProductName}
                  </Checkbox>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Checkbox checked={showColor} onChange={() => setShowColor(!showColor)}>
                    {label[0]?.attributes?.color}
                  </Checkbox>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Checkbox checked={showLength} onChange={() => setShowLength(!showLength)}>
                    {label[0]?.attributes?.length}
                  </Checkbox>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Checkbox checked={showWidth} onChange={() => setShowWidth(!showWidth)}>
                    {label[0]?.attributes?.width}
                  </Checkbox>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Checkbox checked={showHeight} onChange={() => setShowHeight(!showHeight)}>
                    {label[0]?.attributes?.height}
                  </Checkbox>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Checkbox checked={showFinish} onChange={() => setShowFinish(!showFinish)}>
                    {label[0]?.attributes?.finish}
                  </Checkbox>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Checkbox checked={showSize} onChange={() => setShowSize(!showSize)}>
                    {label[0]?.attributes?.Sizeunit}
                  </Checkbox>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Checkbox checked={showDesc} onChange={() => setShowDesc(!showDesc)}>
                    {label[0]?.attributes?.Description}
                  </Checkbox>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Checkbox checked={showMoq} onChange={() => setShowMoq(!showMoq)}>
                    {label[0]?.attributes?.MOQ}
                  </Checkbox>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Checkbox checked={showNTW} onChange={() => setShowNTW(!showNTW)}>
                    {label[0]?.attributes?.NetWgt}
                  </Checkbox>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Checkbox checked={showGRW} onChange={() => setShowGRW(!showGRW)}>
                    {label[0]?.attributes?.GrossWgt}
                  </Checkbox>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item as={Col} colspan={24} md={8}>
                  <Checkbox checked={showMat} onChange={() => setShowMat(!showMat)}>
                    {label[0]?.attributes?.MaterialName}
                  </Checkbox>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </Stack>
          </Panel>
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default ProductFamily;
